import { Headset } from '@phosphor-icons/react';

import { SUPPORT_URL, SUPPORT_USERNAME } from '@shared/config/support';
import { haptics } from '@shared/lib/telegram';
import styles from './SupportFab.module.css';

/** Home-screen support shortcut, positioned above the persistent navigation. */
export function SupportFab() {
  return (
    <a
      className={styles.fab}
      href={SUPPORT_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Contact YeneShop support"
      title={`Contact @${SUPPORT_USERNAME}`}
      onClick={() => haptics.tap()}
    >
      <Headset size={25} weight="bold" aria-hidden="true" />
    </a>
  );
}
